/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-04-16 19:05:50
 * @LastEditors: changfeng
 * @LastEditTime: 2024-06-25 10:27:11
 */
export default {
	"Automated rule turned on": "规则已开启",
	"Automated rule turned off": "规则已关闭",
	"message.success": "成功",
	"message.error": "失败",
	"message.pending": "创建中",
	"message.successfully": "创建成功",
	"message.update.success": "更新成功",

	"message.campaign.No ad groups were able to be copied.": "该广告系列下没有可复制的广告组。",
	"message.campaign.No ads in this ad group": "该广告组下面没有广告",
	"message.tip": "提示",

	"message.adgroup.Template.name": "请输入模板名称",

	"message.create.Ad.material.info": "至少选择一个素材",
	"message.create.Ad.validate.information": "请校验表单信息",
	"message.create.Ad.identity.choose an operation material": "请选中一个操作素材",

	"message.create.Ad.identity.choose.information": "请选择广告发布身份",
	"message.create.Ad.identity.adText": "请输入广告文案（长度为1-100）",
	"message.create.Ad.identity.landingPage": "请输入落地页",

	"message.adParams.check.landingPage.pre": "请为第{{count}}个广告添加landingPageUrl",

	"message.adParams.check.identity.pre": "请为第{{count}}个广告添加发布身份",

	"message.adParams.check.adText.pre": "请为第{{count}}个广告添加广告文案",
	"message.adParams.check.product.pre": "请为第{{count}}个广告添加商品",

	"message.adParams.check.product": "请选择商品",
	"message.adParams.check.product.type": "请选择商品类型",

	"message.creating": "创建中",
	"message.adgroup.creating": "广告组创建中",
	"message.adgroup.creating.failed": "广告组创建失败",
	"message.adgroup.creating.success": "广告组创建成功",

	"message.ad.creating": "广告创建中",
	"message.ad.creating.failed": "广告创建成功",
	"message.ad.creating.success": "广告创建失败",

	"message.create.adgroup.placement.error": "请选择广告位信息",

	"message.upgrade.subscription.plan.success": "请求提交成功。您可以在支付历史中查看结果。",

	"message.copyadgroup.success": "复制广告组成功"
};
